<template>
  <ModalLayout icon="approve-in-circle" :title="`Mark ${meta?.flight ? 'flight' : 'campaign'} as Active?`" @close="close">
    <p>
      This will mark '<strong>{{ name }}</strong
      >' as active, indicating that this campaign has been implemented and is now live as planned. Once active, tracking and reporting will
      begin.
    </p>

    <template slot="footer">
      <el-button class="font-semibold" @click="close">{{ $t('cancel') }}</el-button>
      <el-button class="font-semibold ml-0" type="primary" :loading="loading" @click="active">Mark as Active</el-button>
    </template>
  </ModalLayout>
</template>
<script>
import ModalLayout from './ModalLayout.vue'
export default {
  name: 'MarkAsActive',
  components: { ModalLayout },
  props: {
    meta: {
      type: null,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    name() {
      return this.meta?.flight ? `${this.meta?.flight.name}` : this.meta?.campaign?.name
    },
  },
  methods: {
    close() {
      this.$Modal.instance.isOpen = false
    },
    async active() {
      this.loading = true
      try {
        await this.$store.dispatch('socialBoostCampaign/active', {
          campaign_id: this.meta?.id || this.$route.params.id,
          flight_id: this.meta?.flight_id || this.$route.params.flight_id,
        })
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
        this.$store.dispatch('socialBoostCampaign/getCampaign', { id: this.meta?.id || this.$route.params.id })
        this.close()
      }
    },
  },
}
</script>
